import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ToastContainer } from 'react-toastify';
import FadeLoader from 'react-spinners/FadeLoader';
import { Button, Menu, Icon } from 'antd';
import { isAdmin } from 'modules/account';
import EditableFormTable from './userTable/editableTable';
import AddUserDialog from './addUserDialog';

const { Item } = Menu;
class AdminTool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 'accounts',
      addUserDialogVisible: false,
    }
  }

  componentDidMount() {
    const { accountGetAll } = this.props;
    accountGetAll();
  }

  toggleDialogVisiable = (key, value) => {
    this.setState({
      [key]: value,
    })
  }
  
  handleClick = e => {
    this.setState({
      selectedTab: e.key
    })
  };

  handleUserEdit = (rowData) => {
    const { accountUpdate } = this.props;
    accountUpdate(rowData.id, {
      displayName: rowData.displayName,
      role: rowData.role,
      status: rowData.status,
    })
  };

  renderAddUserButton = () => {
    const { isLoading } = this.props;
    return (
      <Button
        icon='user-add'
        loading={isLoading}
        onClick={() => this.toggleDialogVisiable('addUserDialogVisible', true)}
      >
        Add User
      </Button>
    )
  }

  renderContentList = () => {
    const { accountList } = this.props;
    let accountListWithKey = []
    _.forEach(accountList, (account) => {
      accountListWithKey.push({
        ...account,
        key: account.id,
      })
    });
    return (
      <div>
        { this.renderAddUserButton() }
        <EditableFormTable data={accountListWithKey} onSaveData={this.handleUserEdit}/>
      </div>
    )
  }

  renderNullContent = () => {
    return (
      <div>
        lalalala no account set up yet!!!
      </div>
    )
  }

  renderContent = () => {
    const { isLoading, accountList } = this.props;
    
    return (
      <div className='contentContainer'>
        {
          isLoading && 
          <FadeLoader
            loading={isLoading}
            color={'#FFFFFF'}
          />
        }
        {
          !isLoading && accountList.length > 0 ?
          this.renderContentList() : 
          this.renderNullContent()
        }
      </div>
    )
  }

  renderMenu = () => {
    const { selectedTab } = this.state;
    return (
      <Menu
        className={'menu'}
        onClick={this.handleClick}
        selectedKeys={[selectedTab]}
        mode="inline"
      >
        <Item key="accounts">
          <Icon type="user" />
          Accounts
        </Item>
      </Menu>
    )
  }

  render() {
    const { isLoggedIn, role } = this.props;
    const { addUserDialogVisible } = this.state;
    if (!isLoggedIn || !isAdmin(role)) {
        this.props.history.replace('/')
    }
    return(
      <div className='screen-adminTool gradientColorBackground'>
        <Button onClick={() => {this.props.history.replace('/')}}>return to home</Button>
        <div className='menuContentContainer'>
          { this.renderMenu() }
          { this.renderContent() }
        </div>

        <AddUserDialog
          visible={addUserDialogVisible}
          onCancel={() => { this.toggleDialogVisiable('addUserDialogVisible', false) }}
        />
        <ToastContainer
          autoClose={3000}
          closeButton={false}
          draggable={false}
          hideProgressBar={true}
          style={{ textAlign: 'center' }}
        />
      </div>
    )
  }
}

AdminTool.defaultProps = {
  isLoggedIn: false,
  isLoading: false,
  role: 'user',
  accountList: [],
};

AdminTool.propTypes = {
  isLoggedIn: PropTypes.bool,
  isLoading: PropTypes.bool,
  role: PropTypes.string,
  accountList: PropTypes.array,

  accountGetAll: PropTypes.func.isRequired,
  accountUpdate: PropTypes.func.isRequired,
};

export default AdminTool;
